"use strict";

(function (Drupal) {
  Drupal.behaviors.cursor = {
    attach: function attach(context, settings) {
      var cursorContainer = context.querySelectorAll('.cursor--container');
      if (!cursorContainer.length) {
        return;
      }

      /**
       * Initialize all cursors on the page.
       */
      var initCursors = function initCursors() {
        cursorContainer.forEach(function (container) {
          var cursor = container.querySelector('.cursor');
          TweenMax.set(cursor, {
            xPercent: -50,
            yPercent: -50
          });

          // Fade the cursor in when it enters and run the positioning function.
          container.addEventListener('pointerenter', function (e) {
            TweenMax.to(cursor, 0.3, {
              opacity: 1
            });
            positionCircle(e, cursor, container);
          });

          // Fade the cursor out when it enters and run the positioning function.
          container.addEventListener('pointerleave', function (e) {
            TweenMax.to(cursor, 0.3, {
              opacity: 0
            });
            positionCircle(e, cursor, container);
          });

          // Run the positioning function when we're inside of the carousel.
          container.addEventListener('pointermove', function (e) {
            positionCircle(e, cursor, container);
          });
        });
      };

      /**
       * Position the cursor in the carousel.
       * @param {event} e The event passed from the cursor function.
       * @param {element} cursor The cursor.
       * @param {element} container The container that holds the cursor/sets bounds.
       */
      var positionCircle = function positionCircle(e, cursor, container) {
        var pos = container.getBoundingClientRect();
        var relX = e.pageX - pos.left;
        var relY = e.pageY - pos.top - window.scrollY;
        TweenMax.to(cursor, 0.3, {
          x: relX,
          y: relY
        });
      };
      initCursors();
    }
  };
})(Drupal);